import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { useAIState } from '../../contexts/AIStateContext';
import { AISetupChecklist } from '../AISetupChecklist';

// Live onboarding progress on the Overview dashboard. Self-contained wrapper
// around the existing AISetupChecklist: fetches integration-status, feeds the
// mode/subscription from AIStateContext, and hides once setup is complete (or
// for users without access / non-AI plans).
export default function SetupProgressWidget({ className }) {
  const { effectiveMode, tenantType, billingStatus } = useAIState();
  const [status, setStatus] = useState(null);
  const hasActiveSubscription = tenantType === 'PAID' && billingStatus === 'active';

  useEffect(() => {
    let cancelled = false;
    api.get('/api/tenant/ai/integration-status')
      .then((r) => { if (!cancelled) setStatus(r.data || null); })
      .catch(() => { if (!cancelled) setStatus(null); });
    return () => { cancelled = true; };
  }, []);

  // Nothing to show, or setup already complete → stay out of the way.
  if (!status || status.overall_ready) return null;

  return (
    <div className={className} data-testid="dashboard-setup-progress-widget">
      <AISetupChecklist
        integrationStatus={status}
        effectiveMode={effectiveMode}
        hasActiveSubscription={hasActiveSubscription}
      />
    </div>
  );
}
